import { createContext, useContext } from 'react';
import type { MutableRefObject } from 'react';
import type { Map as LeafletMap } from 'leaflet';

interface FormRendererContextValue {
  mapRef: MutableRefObject<LeafletMap | null>;
  isLoadingSensorData: boolean;
}

const FormRendererContext = createContext<FormRendererContextValue | undefined>(undefined);

export const FormRendererProvider = FormRendererContext.Provider;

export const useFormRendererContext = (): FormRendererContextValue => {
  const ctx = useContext(FormRendererContext);
  if (!ctx) {
    throw new Error('useFormRendererContext must be used within a FormRenderer');
  }
  return ctx;
};
